
<template>
  <div id="app">
    <app-header></app-header>
    <!--<div class="app-header-wrap"></div>-->
    <router-view></router-view>
    <app-footer></app-footer>
    <!-- <sider-lan></sider-lan> -->

    <el-dialog class="contract dialog" top="10%" :visible="contract.show" :before-close="closeContract"
                          :close-on-click-modal="false">
    <h4 slot="title" class="dialog__title">{{contract.title}}</h4>
    <div class="contract__dialog-body" v-html="contract.content"></div>
    <div slot="footer" class="dialog__footer">
      <button class="dialog__footer__confirm-btn" @click="closeContract">I Agree</button>
    </div>
  </el-dialog>


    <el-dialog class="success-modal" top="23%" :visible="successModal.show" :before-close="closeSuccessMessage"
               :close-on-click-modal="false" @close="closeReload">
      <div class="success-modal__text">{{successModal.content}}</div>
    </el-dialog>
    <el-dialog class="fail-modal" top="23%" :visible="failModal.show" :before-close="closeFailMessage"
               :close-on-click-modal="false">
      <div class="fail-modal__text">{{failModal.content}}</div>
    </el-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Cookie from 'js-cookie'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import * as types from './vuex/types'
  import AppHeader from './components/common/Header.vue'
  import AppFooter from './components/common/Footer.vue'
  // import siderLan from './components/sider_lan.vue'

  export default {
//    name: 'app',
    components: {
      AppHeader,
      AppFooter,
      // siderLan
    },
    computed: {
      ...mapGetters({
        contract: types.GET_CONTRACT,
        successModal: types.GET_SUCCESS_MESSAGE,
        failModal: types.GET_FAIL_MESSAGE
      })
    },
    methods: {
      ...mapActions({
        getIndexInfo: types.GET_INDEX_INFO,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      ...mapMutations({
        setRegisterContract: types.SET_CONTRACT_STATE,
        setUserData: types.SET_USER
      }),
      closeSuccessMessage () {
        this.setSuccessMessage({show: false})
      },
      closeFailMessage () {
        this.setFailMessage({show: false})
      },
      closeContract () {
        // closeäº‹ä»¶ä¼¼ä¹Žæ— æ•ˆï¼Ÿç”¨before-closeä»£æ›¿
        this.setRegisterContract({show: false})
      },
      closeReload () {
//        å…³é—­å¼¹æ¡†åˆ·æ–°é¡µé�¢é‡�æ–°èŽ·å�–æ•°æ�®
        if (this.$route.meta.name === 'realNameAuth') {
          this.$router.go(0)
        }
      }
    },
    created () {
      // å¦‚æžœéœ€è¦�è¯·æ±‚æŽ¥å�£è‡ªåŠ¨ç™»å½•ï¼Œåˆ™å�¯ä»¥åœ¨app.vueæ­¤å®Œæˆ�è¯·æ±‚ï¼›ç›®å‰�è®¾è®¡ç•¥ç®€é™‹
      this.setUserData(JSON.parse(decodeURIComponent(!_.isUndefined(Cookie.get('userData')) ? Cookie.get('userData') : '{}')))
    },
    mounted () {
//      this.getIndexInfo()
    }
  }
</script>

<style lang="scss">
  @mixin alertModalStyle {
    .el-dialog {
      margin-bottom: 0;
      width: 550px;
      //height: 223px;
      border-radius: 5px;
    }

    .el-dialog__header {
      @include resetBFC;
      padding: 0 20px;

      .el-dialog__headerbtn {
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }

    .el-dialog__body {
      @include clear;
      box-sizing: border-box;
      display: table;
      padding: 70px 20px;
      width: 100%;
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
      font-size: 12px;
      text-align: center;

      & > div {
        position: relative;
        box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        display: inline-block;
        width: 495px;
        padding-left: 70px;
        word-wrap: break-word;
        word-break: normal;
        line-height: 30px;
        font-size: 16px;
        color: #053A7A;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;

        &:before {
          position: absolute;
          left: 0px;
          top: 50%;
          transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          content: '';
          float: left;
          display: block;
          margin-right: 20px;
          width: 50px;
          height: 50px;
          background-size: cover;
        }
      }
    }
  }

  #app {
    height: 100%;
    /*margin-top: 50px;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    /*color: #2c3e50;*/
    /*overflow-x: hidden;*/

    .app-header-wrap {
      width: 100%;
      height: 51px;
    }
  }

  .success-modal {
    @include alertModalStyle;
  }

  .success-modal__text:before {
    background: url('#{$imagePath}/icons/success_alert_icon.png');
  }

  .fail-modal {
    @include alertModalStyle;
  }

  .fail-modal__text:before {
    background: url('#{$imagePath}/icons/failed_alert_icon.png');
  }

  .el-dialog__header {
    @include resetBFC;

    .el-dialog__headerbtn {
      position: absolute;
      top: 50%;
      right: 20px;
    }
  }

  .dialog__title {
    font-size: 18px;
    font-weight: 700;
  }

  .dialog__footer {
    text-align: center;
  }

  .dialog__footer__confirm-btn {
    border: 0;
    padding: 0 15px;
    min-width: 120px;
    height: 45px;
    border-radius: 3px;
    font-size: 16px;
    color: #fff;
    line-height: 45px;
    text-align: center;
    background: $orange;
    cursor: pointer;

    &:focus, &:active, &:visited {
      border: 0;
    }
  }

  .contract__dialog-body {
    overflow: auto;
    height: 530px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5d88e6c5